import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const opts = {
  theme: {
    dark: true,
    primary: "rgb(255, 192, 0)"
  }
};

export default new Vuetify(opts);
